import React from 'react';

import { LocalOffersLocationContextValue } from './local-offers-location-context.types';

export const LocalOffersLocationContext = React.createContext<LocalOffersLocationContextValue | null>(null);
